module.exports = __webpack_public_path__ + "static/media/ta-2.97078d14.jpeg";